import { css } from '@emotion/css';

export const sidebarStyles = css`
  width: 34rem;
`;
